(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ba-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__baFx)return;window.__baFx=true;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{threshold:.15});
  function scan(){document.querySelectorAll('.ba-reveal:not(.is-in)').forEach(function(el){io.observe(el)})}
  scan();document.addEventListener('shopify:section:load',scan);
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var t=false;window.addEventListener('scroll',function(){if(t)return;t=true;requestAnimationFrame(function(){document.querySelectorAll('[data-ba-parallax]').forEach(function(m){var r=m.parentElement.getBoundingClientRect();m.style.transform='translate3d(0,'+(-r.top*0.25)+'px,0) scale(1.05)';});t=false;});},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ba-shop-the-look"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var pics=root.querySelectorAll('[data-look-pic]'),count=root.querySelector('[data-look-count]');
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;var i=e.target.getAttribute('data-look');
      pics.forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-look-pic')===i)});
      if(count)count.textContent=('0'+(+i+1)).slice(-2);});},{rootMargin:'-45% 0px -45% 0px'});
    root.querySelectorAll('[data-look]').forEach(function(l){io.observe(l)});
  }
  function scan(){document.querySelectorAll('.ba-stl:not([data-ready])').forEach(function(r){r.setAttribute('data-ready','');init(r)})}
  scan();document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
